export const isInStock = (status) => /^IN_STOCK$/i.test(status);
//# sourceMappingURL=isInStock.js.map